export default {
    received: function(notifications) {
        return {
            type: 'NOTIFICATIONS_RECEIVED',
            notifications
        };
    },
    markRead: id => ({type: 'NOTIFICATION_READ', id})
};
